import 'intersection-observer'
import 'picturefill'

import Vue from 'vue'
import App from '@/App'
import store from '@store'
import router from '@router'
import Plugins from '@/plugins'
import { release } from '../release'
import * as Sentry from '@sentry/vue'
import { Replay } from '@sentry/browser'
import {
  HttpClient as HttpClientIntegration
} from '@sentry/integrations'
import { BrowserTracing } from '@sentry/tracing'
import i18n from '@/i18n'
import { FEEDBACK } from '@/store/types'
import VueLazyload from 'vue-lazyload'
import { makeServer } from '@/mocks/server'

Vue.use(VueLazyload)

if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging') {
  Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DSN_KEY,
    release: 'clube-clube-front@' + release,
    integrations: [
      new BrowserTracing(),
      new HttpClientIntegration({
        // failedRequestStatusCodes: [[500, 505], 507],
        failedRequestTargets: [
          process.env.GRAPHQL_API + 'general',
          process.env.GRAPHQL_API,
          process.env.RESTFUL_API
        ]
      }),
      new Replay({
        maskAllText: false,
        blockAllMedia: false
      })
    ],
    tracesSampleRate: 0,
    debug: true,
    logErrors: true,
    MinimumEventLevel: 'Error',
    sendDefaultPii: true,
    ignoreErrors: [
      'Failed to fetch',
      'Network request failed',
      'Failed to fetch',
      'Request aborted',
      'Network Error',
      'Non-Error promise rejection captured',
      'Navigation cancelled from',
      'Navigation aborted from',
      'Avoided redundant navigation to current location',
      'Blocked a frame with origin',
      /Loading chunk [\d] failed/,
      'Hotjar Tracking Warning',
      'chrome_debugger_trace',
      'InstantSearch',
      'Tasks: current',
      'FBNavDomContentLoaded',
      'FBNavResponseEnd',
      '{"type":"exposedFun","name":"reportChangesGlobal"',
      '~ [\d].b.push (https://www.googletagmanager.com/',
      'Loading chunk'
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0
  })
  Sentry.configureScope(function (scope) {
    scope.setLevel('error')
  })
}

if (process.env.USE_MOCK) {
  makeServer()
}

Vue.use(Plugins)
/**
 * Resolve o erro causado pelo uso do `process.env` (DedupePlugin) usado
 * numa expressão passada como argumento para o `import` dinâmico que não
 * é resolvida durante a eliminação de código morto.
 */
window.process = {
  ...process,
  env: {
    ...process && process.env,
    NODE_ENV: process && process.env && process.env.NODE_ENV
  }
}

if (process.env.NODE_ENV !== 'production') {
  Vue.config.devtools = true
  Vue.config.performance = true
}

if (window.Cypress) {
  // Add `store` to the window object only when testing with Cypress
  window.__store__ = store
}

let lastError = {}
Vue.config.errorHandler = (msg, info) => {
  if (lastError.info !== info && lastError.msg !== msg) {
    lastError = { info, msg }
    // if (process.env.NODE_ENV !== 'production') {
    //   console.log('Ocorreu um erro: ', info, msg)
    // }
    console.log('Ocorreu um erro: ', info, msg)
    store.dispatch(FEEDBACK, {
      text: 'Ocorreu um problema, caso o erro persista entre em contato com a equipe de suporte.',
      type: 'error'
    })
  }
}

const app = new Vue({
  el: '#app',
  i18n,
  store,
  router,
  render: (λ) => λ(App)
})

global.EventBus = app



// WEBPACK FOOTER //
// ./src/index.js